module.exports = __webpack_public_path__ + "img/Mobile_topbar_Logo.1887567d.svg";